import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { FeatureFlagService } from 'app/core/services/feature-flag.service';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { LockedFieldsEditComponent } from './locked-fields-edit/locked-fields-edit.component';
import { LockedFieldsListComponent } from './locked-fields-list/locked-fields-list.component';
import { LockedFieldsRoutingModule } from './locked-fields-routing.module';
import { LockedFieldsComponent } from './locked-fields.component';
import { LockableFieldsResolver } from './locked-fields.resolvers';
import { LockedFieldService } from './services/locked-fields.service';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { TsTableComponent } from 'tsui/lib/ts-table';
import {
  TsBadgeModule,
  TsButtonModule,
  TSIconModule,
  TsInputComponent,
  TsMenuComponent,
  TsOverlayModule,
  TsPageComponent,
  TsPageHeaderModule,
  TsPaginatorModule,
} from 'tsui';
import { TsTabGroupComponent } from 'tsui/lib/ts-tab-group/ts-tab-group.component';

@NgModule({
  declarations: [LockedFieldsComponent, LockedFieldsListComponent, LockedFieldsEditComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LockedFieldsRoutingModule,
    MatProgressBarModule,
    MatListModule,
    PipesModule,
    MatTableModule,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    MatTabsModule,
    MatInputModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatPaginatorModule,
    TsTableComponent,
    TsPaginatorModule,
    TsPageComponent,
    TsPageHeaderModule,
    TsButtonModule,
    TsInputComponent,
    TsBadgeModule,
    TsOverlayModule,
    TSIconModule,
    TsMenuComponent,
    TsTabGroupComponent,
  ],
  providers: [LockedFieldService, LockableFieldsResolver, FeatureFlagService],
})
export class LockedFieldsModule {}
